import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LoadingState {
  isLoading: boolean;
  message: string;
  type: 'auth' | 'logout' | 'callback' | 'general';
}

@Injectable({
  providedIn: 'root'
})
export class LoadingStateService {
  private loadingSubject = new BehaviorSubject<LoadingState>({
    isLoading: false,
    message: '',
    type: 'general'
  });

  public loading$ = this.loadingSubject.asObservable();

  showLoading(message: string, type: 'auth' | 'logout' | 'callback' | 'general' = 'general'): void {
    this.loadingSubject.next({
      isLoading: true,
      message,
      type
    });
  }

  hideLoading(): void {
    this.loadingSubject.next({
      isLoading: false,
      message: '',
      type: 'general'
    });
  }

  getCurrentState(): LoadingState {
    return this.loadingSubject.value;
  }
}
